import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _4b5257ba = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _6c5719e3 = () => interopDefault(import('..\\pages\\path.vue' /* webpackChunkName: "pages_path" */))
const _611cf858 = () => interopDefault(import('..\\pages\\reimbursement\\index.vue' /* webpackChunkName: "pages_reimbursement_index" */))
const _a93de78a = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _78a50f84 = () => interopDefault(import('..\\pages\\selection.vue' /* webpackChunkName: "pages_selection" */))
const _e64dc7fc = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _52fd3dd9 = () => interopDefault(import('..\\pages\\enroll\\eligibility.vue' /* webpackChunkName: "pages_enroll_eligibility" */))
const _20f995a0 = () => interopDefault(import('..\\pages\\enroll\\patient-information.vue' /* webpackChunkName: "pages_enroll_patient-information" */))
const _5e779be8 = () => interopDefault(import('..\\pages\\enroll\\prescriber-information.vue' /* webpackChunkName: "pages_enroll_prescriber-information" */))
const _367a294f = () => interopDefault(import('..\\pages\\enroll\\success.vue' /* webpackChunkName: "pages_enroll_success" */))
const _e8ad4a4a = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _e8911b48 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _e858bd44 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _e83c8e42 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _7ee0d3c8 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _078c3984 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _4b5257ba,
    name: "error"
  }, {
    path: "/path",
    component: _6c5719e3,
    name: "path"
  }, {
    path: "/reimbursement",
    component: _611cf858,
    name: "reimbursement"
  }, {
    path: "/rejection",
    component: _a93de78a,
    name: "rejection"
  }, {
    path: "/selection",
    component: _78a50f84,
    name: "selection"
  }, {
    path: "/unlock",
    component: _e64dc7fc,
    name: "unlock"
  }, {
    path: "/enroll/eligibility",
    component: _52fd3dd9,
    name: "enroll-eligibility"
  }, {
    path: "/enroll/patient-information",
    component: _20f995a0,
    name: "enroll-patient-information"
  }, {
    path: "/enroll/prescriber-information",
    component: _5e779be8,
    name: "enroll-prescriber-information"
  }, {
    path: "/enroll/success",
    component: _367a294f,
    name: "enroll-success"
  }, {
    path: "/errors/400",
    component: _e8ad4a4a,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _e8911b48,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _e858bd44,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _e83c8e42,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _7ee0d3c8,
    name: "errors-500"
  }, {
    path: "/",
    component: _078c3984,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
